<div id="table-filter-container">
  <!-- if the column is not filterable then just show it as a disabled text box. -->
  <div>
    @if (col.filterable === false) {
      <input pInputText type="text" [ngModel]="col.defaultValue" disabled />
    } @else {
      <!-- filterable column that has a type of drop down. -->
      <div>
        @if (col.type === 'dropdown') {
          <p-select
            appendTo="body"
            [style]="{ width: '100%' }"
            [options]="col.options"
            [(ngModel)]="col.value"
            (onChange)="
              this.filterEvent.emit({
                value: $event.value,
                field: col.field,
                matchMode: col.matchMode ? col.matchMode : 'equals',
              })
            "
          />
        }
      </div>
      <!-- filterable column that has a type of calendar. Do not wrap in a padded div as the component has that.-->
      @if (col.type === 'calendar' && !col.formControl) {
        <app-datepicker
          appendTo="body"
          (selected)="
            this.filterEvent.emit({
              value: $event,
              field: col.field,
              matchMode: col.matchMode ? col.matchMode : 'equals',
            })
          "
          [ngModel]="col.value"
        />
      }
      @if (col.type === 'calendar' && col.formControl) {
        <app-datepicker
          [formControl]="col.formControl"
          appendTo="body"
          [ngModel]="col.value"
          (selected)="
            this.filterEvent.emit({
              value: $event,
              field: col.field,
              matchMode: 'equals',
            })
          "
        />
      }
      <!-- if the column supports formControl validations -->
      @if (
        col.formControl &&
        !col.maxLength &&
        (col.type === null || col.type === undefined || col.type === 'input')
      ) {
        <div>
          <input
            pInputText
            type="text"
            [class]="getStyleClass(col)"
            (input)="emitInputFilter($event, col)"
            [formControl]="col.formControl"
            [ngModel]="col.value"
          />
        </div>
      }
      @if (
        col.formControl &&
        col.maxLength &&
        (col.type === null || col.type === undefined || col.type === 'input')
      ) {
        <div>
          <input
            pInputText
            type="text"
            [class]="getStyleClass(col)"
            (input)="emitInputFilter($event, col)"
            [formControl]="col.formControl"
            [maxLength]="col.maxLength"
            [ngModel]="col.value"
          />
        </div>
      }
      <!-- if the column does not support formControl validations -->
      @if (
        !col.formControl &&
        !col.maxLength &&
        (col.type === null || col.type === undefined || col.type === 'input')
      ) {
        <div>
          <input
            pInputText
            type="text"
            [ngModel]="col.value"
            (input)="emitInputFilter($event, col)"
          />
        </div>
      }
      @if (
        !col.formControl &&
        col.maxLength &&
        (col.type === null || col.type === undefined || col.type === 'input')
      ) {
        <div>
          <input
            pInputText
            type="text"
            [ngModel]="col.value"
            (input)="emitInputFilter($event, col)"
            [maxLength]="col.maxLength"
          />
        </div>
      }
    }
  </div>
</div>
